import React, { Component } from "react"
import Slider from "react-slick"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Loader from "../common/loader"
import { getTestimonials } from "./../../services/testimonialService"

class TestimonialSlider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      testimonialItems: [],
      loading: true,
    }
  }

  async componentDidMount() {
    const { data: testimonialItems } = await getTestimonials()
    this.setState({ testimonialItems, loading: false })
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      arrows: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }

    if (this.state.loading) return <Loader />
    return (
      <Slider {...settings}>
        {this.state.testimonialItems.map(item => (
          <div className="mr-3" key={item.id}>
            <div className="testimonial-item">
              <div className="single-slide">
                <div className="">
                  <LazyLoadImage
                    className="slide-img"
                    src={item.Image.url}
                    alt={item.Name}
                  />
                </div>
                <div className="content">
                  <LazyLoadImage
                    src={require("../../../static/images/testimonials/review.png")}
                  />
                  <p>{item.Description}</p>
                  <h4>- {item.Name}</h4>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    )
  }
}

export default TestimonialSlider
